import { render, staticRenderFns } from "./account-table.vue?vue&type=template&id=a521b320&scoped=true"
import script from "./account-table.vue?vue&type=script&lang=js"
export * from "./account-table.vue?vue&type=script&lang=js"
import style0 from "./account-table.vue?vue&type=style&index=0&id=a521b320&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a521b320",
  null
  
)

export default component.exports